var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7395 10.7224L7.6665 14.7957C7.528 14.934 7.35391 15.0049 7.14425 15.0082C6.93475 15.0114 6.7575 14.9405 6.6125 14.7957C6.46767 14.6507 6.39525 14.475 6.39525 14.2687C6.39525 14.0624 6.46767 13.8867 6.6125 13.7417L11.1067 9.24745C11.2004 9.15395 11.2992 9.08795 11.403 9.04945C11.5068 9.01095 11.619 8.9917 11.7395 8.9917C11.86 8.9917 11.9722 9.01095 12.076 9.04945C12.1798 9.08795 12.2786 9.15395 12.3722 9.24745L16.8665 13.7417C17.0048 13.8802 17.0757 14.0543 17.079 14.2639C17.0822 14.4734 17.0113 14.6507 16.8665 14.7957C16.7215 14.9405 16.5458 15.0129 16.3395 15.0129C16.1332 15.0129 15.9575 14.9405 15.8125 14.7957L11.7395 10.7224Z",
    fill: "#101014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpBlack);
export default __webpack_public_path__ + "static/media/up_black.c35869df109c079836208a130f439261.svg";
export { ForwardRef as ReactComponent };